import React, { FC } from 'react'
import { Box, Grid, Skeleton, theme } from '@lojinha/design-system'

export const LoadingPurchases: FC = () => {
  return (
    <Grid gridTemplateColumns={['repeat(12, 1fr)']}>
      <Grid gridColumn={['1 / 13']}>
        <Box marginBottom={'x40'} height={[212, 200]}>
          <Skeleton />
        </Box>
      </Grid>
      <Grid gridColumn={['2 / 4', '2, 6']}>
        <Box marginBottom={'x24'} height={[16, 24]}>
          <Skeleton htmlAttrs={{ style: { borderRadius: theme.space.x4 } }} />
        </Box>
      </Grid>
      <Grid gridColumn={['2 / 12']}>
        {[...Array(4)].map((_, i) => {
          return (
            <Box marginBottom={'x16'} key={i} height={[65, 128]}>
              <Skeleton
                htmlAttrs={{ style: { borderRadius: theme.space.x8 } }}
              />
            </Box>
          )
        })}
      </Grid>
    </Grid>
  )
}
